export function zReplace(value: string | number, regexStr: string, replaceValue = '') {
  if (!value) {
    return value.toString();
  }

  const str = value.toString();
  const regex = new RegExp(regexStr, 'g');
  return str.replace(regex, replaceValue);
}
